/* eslint-disable indent */
/* eslint-disable max-statements */
/* eslint-disable max-lines-per-function */
// Component
import { MAKER_CHECKER_EVENT_TYPES } from 'utils/constants/commonValues';

// Actions

// Constant

// Validator
import { useHistory } from 'react-router-dom';
// Data

// Libraries
import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, change as changeFormValue, FieldArray } from 'redux-form';
import { compose, bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { last } from 'lodash';
import DatePicker from "react-datepicker";

import { SUCCESS_MESSAGES } from '../../utils/constants/toastMessages';
import {
    updateSectionDataRequest,
    resetUpdateDataSuccessKey,
    getMerchantSectionInfoRequest,
    addMerchantStepUpdateMakerRequest,
} from '../../containers/MerchantOnboard/redux/editMerchant/editMerchant.actions';
import {
    saveAndContinueRequest,
    resetSaveDataSuccessKey,
} from '../../containers/MerchantOnboard/redux/merchantOnBoard.actions';
import { FormElems, Alert, Accordion } from '../../components/';
import {
    modeOfIntegration,
    security,
    keyMode,
    platform,
    allowRetry,
    sftpReport,
    mtrViaEmailRequired,
    instantRollback,
    isMerchantTatEnabled,
    isMandateRegTatEnabled,
    refundRetry,
    refundQueue,
    verifiedPayment,
    instantRefund,
    isFcMerchant,
    isStaticQREnabled,
    isMultiAttemptOnPayLink,
    allowOpenMultiPaymentLink,
    getKeyMode,
    allowFPS,
    isEncryptionEnabled,
    threeDimensionSecurityBrowserInfoCollect,
    threeDimensionSecurityInfoHardCoded,
    merchantTxnLimit,
    entityStatus,
    isDomainWhitelisted,
} from './dummyData';
import validate from './validator';

// Styles
import './integrationTab.scss';
import Tooltip from 'rc-tooltip';
import infoIcon from '../../static/images/blackinfo.png';
import RenderDomainFields from './RenderDomainFields';

const getRequestValues = values => {
    const data = {};
    if (Array.isArray(values)) {
        values.forEach(element => {
            if (typeof element === 'string' || element instanceof String) {
                data[element] = true;
            }
        });
        return data;
    } else if (typeof values === 'object' || values instanceof Object) {
        for (const property in values) {
            if (Object.prototype.hasOwnProperty.call(values, property)) {
                if (values[property]) {
                    data[property] = values[property];
                }
            }
        }
        return data;
    }
    data[values] = true;
    return data;
};

const convertToEpoch = (dateObject) => {
    if (!dateObject || !(dateObject instanceof Date)) {
        return null;
    }
    return Date.UTC(dateObject.getFullYear(), dateObject.getMonth(), dateObject.getDate(), 0, 0, 0);
};

const extractWhitelistedDomains = (input) =>{
    return input
      .map(item => item.domain)
      .filter(domain => typeof domain === 'string' && domain.trim() !== '');
  }

const convertToWhitelistedDomains=(domains)=>{
    return domains.map(domain => ({ domain }));
  }

const convertFromEpoch = (epoch) => {
    if (!epoch || isNaN(epoch)) {
        return null;
    }
    return new Date(parseInt(epoch, 10));
};

const getOptions = (initialValuesData, data, keyField, renderComponentData) => {
    const getItemWithComponent = (item, renderComponentData, index) => {
        if (renderComponentData && renderComponentData.index === index) {
            return {
                ...item,
                renderComponent: renderComponentData.component,
            };
        }
        return item;
    };

    if (
        initialValuesData &&
        initialValuesData[keyField] &&
        Object.keys(initialValuesData[keyField]).length
    ) {
        const allSelectedValues = [];
        for (const property in initialValuesData[keyField]) {
            if (initialValuesData[keyField][property]) {
                allSelectedValues.push(property);
            }
        }

         return data.map((item, index) => {
                if (allSelectedValues.includes(item.value)) {
                    return {
                        ...item,
                        ...getItemWithComponent(item, renderComponentData, index),
                        checked: true,
                    };
                }
                return getItemWithComponent(item, renderComponentData, index);
            });
        }
        return data.map((item, index) => {
            return {
                ...item,
                ...getItemWithComponent(item, renderComponentData, index),
            };
        });
};

const getCheckboxOptions = (initialValuesData, data, keyField) => {
    if (initialValuesData && initialValuesData[keyField]) {
        return data.map(item => {
            if (initialValuesData[keyField]) {
                return { ...item, checked: true };
            }
            return item;
        });
    }
    return data;
};

const IntegrationTab = ({
    merchantData,
    nextPath,
    previousPath,
    history,
    handleSubmit,
    actions,
    sectionType,
    name,
    formData,
    isEditMode,
    isViewMode,
    change,
    initialValues,
    editData,
    auth,
}) => {
    const {
        saveData,
        uniqueIdentifier: { uniqueId },
        timeline: { fields },
    } = merchantData;
    const { updateData } = editData;
    const { location } = history;
    const dispatch = useDispatch();
    const [showCount, setShowCount] = useState(false);
    const [showMerchantTxnTat, setShowMerchantTxnTat] = useState(false);
    const [showEncryptionKeys, setShowEncryptionKeys] = useState(false);
    const [showDomains, setShowDomains] = useState(false);
    const [showPayLinkConfigs, setShowPayLinkConfigs] = useState(false);
    const [statusOptions, setStatusOptions] = useState(entityStatus);
    const [showMandateRegTxnTat, setShowMandateRegTxnTat] = useState(false);
    const [certificateDate, setCertificateDate] = useState(null);
    const [errorMessage, setErrorMessage] = useState('');

    const history2 = useHistory();
    const [showRefundQueueTat, setShowRefundQueueTat] = useState(true);

    const resetErrors = () => {
        if (isEditMode) {
            actions.resetUpdateDataSuccessKey();
        } else {
            actions.resetSaveDataSuccessKey();
        }
    };

    useEffect(() => {
        if (formData.initial.entityStatus === 'INACTIVE_WITH_SETTLEMENT') {
            setStatusOptions(preState => {
                const newState = [...preState];
                newState[2] = {
                    name: 'Inactive With Settlement',
                    value: 'INACTIVE_WITH_SETTLEMENT',
                };
                return newState;
            });
        }
    }, [formData.initial]);

    useEffect(() => {
        const portalValue = formData.values.allowRetry;
        if (portalValue === true || portalValue === 'allowRetry') {
            change('allowRetry', true);
            setShowCount(true);
        } else if (
            Array.isArray(portalValue) &&
            portalValue.includes('allowRetry')
        ) {
            change('allowRetry', true);
            setShowCount(true);
        } else {
            change('allowRetry', false);
            change('retryCount', null);
            setShowCount(false);
        }
    }, [change, formData.values.allowRetry]);

    useEffect(() => {
        const portalValue = formData.values.isMerchantTatEnabled;
        if (portalValue === true || portalValue === 'isMerchantTatEnabled') {
            change('isMerchantTatEnabled', true);
            setShowMerchantTxnTat(true);
        } else if (
            Array.isArray(portalValue) &&
            portalValue.includes('isMerchantTatEnabled')
        ) {
            change('isMerchantTatEnabled', true);
            setShowMerchantTxnTat(true);
        } else {
            change('isMerchantTatEnabled', false);
            change('merchantTxnTat', null);
            setShowMerchantTxnTat(false);
        }
    }, [change, formData.values.isMerchantTatEnabled]);

    useEffect(() => {
        const portalValue = formData.values.isMandateRegTatEnabled;
        if (portalValue === true || portalValue === 'isMandateRegTatEnabled') {
            change('isMandateRegTatEnabled', true);
            setShowMandateRegTxnTat(true);
        } else if (
            Array.isArray(portalValue) &&
            portalValue.includes('isMandateRegTatEnabled')
        ) {
            change('isMandateRegTatEnabled', true);
            setShowMandateRegTxnTat(true);
        } else {
            change('isMandateRegTatEnabled', false);
            change('mandateRegApprovalTat', null);
            setShowMandateRegTxnTat(false);
        }
    }, [change, formData.values.isMandateRegTatEnabled]);

    useEffect(() => {
        const portalValue = formData.values.isEncryptionEnabled;
        if (portalValue === true || portalValue === 'isEncryptionEnabled') {
            change('isEncryptionEnabled', true);
            setShowEncryptionKeys(true);
        } else if (
            Array.isArray(portalValue) &&
            portalValue.includes('isEncryptionEnabled')
        ) {
            change('isEncryptionEnabled', true);
            setShowEncryptionKeys(true);
        } else {
            change('isEncryptionEnabled', false);
            setShowEncryptionKeys(false);
        }
    }, [change, formData.values.isEncryptionEnabled]);
    useEffect(() => {
        const portalValue = formData.values.isDomainWhitelisted;
        if (portalValue === true || portalValue === 'isDomainWhitelisted') {
            change('isDomainWhitelisted', true);
            setShowDomains(true);
        } else if (
            Array.isArray(portalValue) &&
            portalValue.includes('isDomainWhitelisted')
        ) {
            change('isDomainWhitelisted', true);
            setShowDomains(true);
        } else {
            change('isDomainWhitelisted', false);
            setShowDomains(false);
        }
    }, [change, formData.values.isDomainWhitelisted]);

    useEffect(() => {
        const portalValue =
            formData.values.threeDimensionSecurityBrowserInfoCollect;
        if (
            portalValue === true ||
            portalValue === 'threeDimensionSecurityBrowserInfoCollect'
        ) {
            change('threeDimensionSecurityBrowserInfoCollect', true);
        } else if (
            Array.isArray(portalValue) &&
            portalValue.includes('threeDimensionSecurityBrowserInfoCollect')
        ) {
            change('threeDimensionSecurityBrowserInfoCollect', true);
        } else {
            change('threeDimensionSecurityBrowserInfoCollect', false);
        }
    }, [change, formData.values.threeDimensionSecurityBrowserInfoCollect]);

    useEffect(() => {
        const portalValue = formData.values.threeDimensionSecurityInfoHardCoded;
        if (
            portalValue === true ||
            portalValue === 'threeDimensionSecurityInfoHardCoded'
        ) {
            change('threeDimensionSecurityInfoHardCoded', true);
        } else if (
            Array.isArray(portalValue) &&
            portalValue.includes('threeDimensionSecurityInfoHardCoded')
        ) {
            change('threeDimensionSecurityInfoHardCoded', true);
        } else {
            change('threeDimensionSecurityInfoHardCoded', false);
        }
    }, [change, formData.values.threeDimensionSecurityInfoHardCoded]);

    useEffect(() => {
        const portalValue = formData.values.isMtrViaEmailRequired;
        if (portalValue === true || portalValue === 'isMtrViaEmailRequired') {
            change('isMtrViaEmailRequired', true);
        } else if (
            Array.isArray(portalValue) &&
            portalValue.includes('isMtrViaEmailRequired')
        ) {
            change('isMtrViaEmailRequired', true);
        } else {
            change('isMtrViaEmailRequired', false);
        }
    }, [change, formData.values.isMtrViaEmailRequired]);

    useEffect(() => {
        const portalValue = formData.values.isSftpRequired;
        if (portalValue === true || portalValue === 'isSftpRequired') {
            change('isSftpRequired', true);
        } else if (
            Array.isArray(portalValue) &&
            portalValue.includes('isSftpRequired')
        ) {
            change('isSftpRequired', true);
        } else {
            change('isSftpRequired', false);
        }
    }, [change, formData.values.isSftpRequired]);

    useEffect(() => {
        const portalValue = formData.values.isMerTxnLimitEnabled;
        if (portalValue === true || portalValue === 'isMerTxnLimitEnabled') {
            change('isMerTxnLimitEnabled', true);
        } else if (
            Array.isArray(portalValue) &&
            portalValue.includes('isMerTxnLimitEnabled')
        ) {
            change('isMerTxnLimitEnabled', true);
        } else {
            change('isMerTxnLimitEnabled', false);
        }
    }, [change, formData.values.isMerTxnLimitEnabled]);

    useEffect(() => {
        const portalValue = formData.values.refundRetry;
        if (portalValue === true || portalValue === 'refundRetry') {
            change('refundRetry', true);
        } else if (
            Array.isArray(portalValue) &&
            portalValue.includes('refundRetry')
        ) {
            change('refundRetry', true);
        } else {
            change('refundRetry', false);
        }
    }, [change, formData.values.refundRetry]);
    useEffect(() => {
        const portalValue = formData.values.verifiedPayment;
        if (portalValue === true || portalValue === 'verifiedPayment') {
            change('verifiedPayment', true);
        } else if (
            Array.isArray(portalValue) &&
            portalValue.includes('verifiedPayment')
        ) {
            change('verifiedPayment', true);
        } else {
            change('verifiedPayment', false);
        }
    }, [change, formData.values.verifiedPayment]);

    useEffect(() => {
        const portalValue = formData.values.isFcMerchant;
        if (portalValue === true || portalValue === 'isFcMerchant') {
            change('isFcMerchant', true);
        } else if (
            Array.isArray(portalValue) &&
            portalValue.includes('isFcMerchant')
        ) {
            change('isFcMerchant', true);
        } else {
            change('isFcMerchant', false);
        }
    }, [change, formData.values.isFcMerchant]);

    useEffect(() => {
        const portalValue = formData.values.isStaticQREnabled;
        if (portalValue === true || portalValue === 'isStaticQREnabled') {
            change('isStaticQREnabled', true);
        } else if (
            Array.isArray(portalValue) &&
            portalValue.includes('isStaticQREnabled')
        ) {
            change('isStaticQREnabled', true);
        } else {
            change('isStaticQREnabled', false);
        }
    }, [change, formData.values.isStaticQREnabled]);

    useEffect(() => {
        const portalValue = formData.values.isMultiAttemptOnPayLink;
        if (portalValue === true || portalValue === 'isMultiAttemptOnPayLink') {
            change('isMultiAttemptOnPayLink', true);
            setShowPayLinkConfigs(true);
        } else if (
            Array.isArray(portalValue) &&
            portalValue.includes('isMultiAttemptOnPayLink')
        ) {
            change('isMultiAttemptOnPayLink', true);
            setShowPayLinkConfigs(true);
        } else {
            change('isMultiAttemptOnPayLink', false);
            setShowPayLinkConfigs(false);
        }
    }, [change, formData.values.isMultiAttemptOnPayLink]);

    useEffect(() => {
        const portalValue = formData.values.allowOpenMultiPaymentLink;
        if (
            portalValue === true ||
            portalValue === 'allowOpenMultiPaymentLink'
        ) {
            change('allowOpenMultiPaymentLink', true);
        } else if (
            Array.isArray(portalValue) &&
            portalValue.includes('allowOpenMultiPaymentLink')
        ) {
            change('allowOpenMultiPaymentLink', true);
        } else {
            change('allowOpenMultiPaymentLink', false);
        }
    }, [change, formData.values.allowOpenMultiPaymentLink]);

    useEffect(() => {
        const portalValue = formData.values.instantRollback;
        if (portalValue === true || portalValue === 'instantRollback') {
            change('instantRollback', true);
        } else if (
            Array.isArray(portalValue) &&
            portalValue.includes('instantRollback')
        ) {
            change('instantRollback', true);
        } else {
            change('instantRollback', false);
        }
    }, [change, formData.values.instantRollback]);

    useEffect(() => {
        const portalValue = formData.values.instantRefund;
        if (portalValue === true || portalValue === 'instantRefund') {
            change('instantRefund', true);
        } else if (
            Array.isArray(portalValue) &&
            portalValue.includes('instantRefund')
        ) {
            change('instantRefund', true);
        } else {
            change('instantRefund', false);
        }
    }, [change, formData.values.instantRefund]);

    useEffect(() => {
        const portalValue = formData.values.allowFPS;
        if (portalValue === true || portalValue === 'allowFPS') {
            change('allowFPS', true);
        } else if (
            Array.isArray(portalValue) &&
            portalValue.includes('allowFPS')
        ) {
            change('allowFPS', true);
        } else {
            change('allowFPS', false);
        }
    }, [change, formData.values.allowFPS]);

    useEffect(() => {
        resetErrors();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (isEditMode || isViewMode) {
            const merchantId = last(location.pathname.split('/'));
            actions.getMerchantSectionInfoRequest(
                merchantId,
                fields,
                'integrationSection',
                history2
            );
        }
    }, [actions, fields, isEditMode, isViewMode, location.pathname, history2]);

    const onBack = () => {
        resetErrors();
        history.push(previousPath);
    };

    const onNext = () => {
        resetErrors();
        history.push(nextPath);
    };

    useEffect(() => {
        if (saveData.isSuccess && saveData.sectionType === sectionType) {
            toast.info(SUCCESS_MESSAGES.SAVE_DATA(name));
            onNext();
        }
        return () => {
            if (saveData.isSuccess && saveData.sectionType === sectionType) {
                actions.resetSaveDataSuccessKey();
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [saveData.isSuccess, saveData.sectionType]);

    useEffect(() => {
        if (updateData.isUpdated && updateData.sectionType === sectionType) {
            toast.info(SUCCESS_MESSAGES.UPDATE_MAKER_REQUEST_SUCCESS(name));
            onNext();
        }
        return () => {
            if (
                updateData.isUpdated &&
                updateData.sectionType === sectionType
            ) {
                actions.resetUpdateDataSuccessKey();
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updateData.isUpdated, updateData.sectionType]);

    const getRefundQueueValue = formData => {
        const refundQueue = formData.values.refundQueue;
        if (typeof refundQueue === 'boolean') {
            return refundQueue;
        }
        if (Array.isArray(refundQueue)) {
            return refundQueue.includes('refundQueue');
        }
        return false;
    };

    const refundQueueValue = getRefundQueueValue(formData);

    useEffect(() => {
            if(refundQueueValue){
                const newValue = formData.initial.refundQueueTat ?? '1440';
                change("refundQueueTat", newValue);
            }else {
                change( 'refundQueueTat', null);
            }
    }, [refundQueueValue, formData.initial.refundQueueTat]);

    const handleFormSubmit = values => {
        if(errorMessage){
            return;
        }
        const valuesCopy = {};
        valuesCopy.modeOfIntegration = getRequestValues(
            values.modeOfIntegration
        );
        valuesCopy.entityStatus = values.entityStatus;
        valuesCopy.security = getRequestValues(values.security);
        valuesCopy.keyMode = getRequestValues(values.keyMode);
        valuesCopy.platform = getRequestValues(values.platform);
        valuesCopy.instantRollback = values.instantRollback || false;
        valuesCopy.instantRefund = values.instantRefund || false;
        valuesCopy.allowRetry = values.allowRetry || false;
        valuesCopy.isSftpRequired = values.isSftpRequired || false;
        valuesCopy.isMerTxnLimitEnabled = values.isMerTxnLimitEnabled || false;
        valuesCopy.isDomainWhitelisted = values.isDomainWhitelisted || false;
        if (valuesCopy.isMerTxnLimitEnabled) {
            valuesCopy.perTransactionLimit = parseInt(
                values?.perTransactionLimit,
                10
            );
            valuesCopy.dailyTransactionLimit = parseInt(
                values?.dailyTransactionLimit,
                10
            );
            valuesCopy.monthlyTransactionLimit = parseInt(
                values?.monthlyTransactionLimit,
                10
            );
        }
        valuesCopy.isMtrViaEmailRequired =
            values.isMtrViaEmailRequired || false;
        valuesCopy.refundRetry = values.refundRetry || false;
        valuesCopy.refundQueue = getRefundQueueValue({ values }) || false;
        if (valuesCopy.refundQueue) {
            valuesCopy.refundQueueTat = values.refundQueueTat || 0;
        } else {
            valuesCopy.refundQueueTat = null;
        }
        valuesCopy.verifiedPayment = values.verifiedPayment || false;
        valuesCopy.isFcMerchant = values.isFcMerchant || false;
        valuesCopy.isStaticQREnabled = values.isStaticQREnabled || false;
        valuesCopy.allowFPS = values.allowFPS || false;
        valuesCopy.isMultiAttemptOnPayLink =
            values.isMultiAttemptOnPayLink || false;
        valuesCopy.retryCount = values.retryCount;
        valuesCopy.threeDimensionSecurityBrowserInfoCollect =
            values.threeDimensionSecurityBrowserInfoCollect || false;
        valuesCopy.threeDimensionSecurityInfoHardCoded =
            values.threeDimensionSecurityInfoHardCoded || false;
        valuesCopy.isMerchantTatEnabled = values.isMerchantTatEnabled || false;
        valuesCopy.isEncryptionEnabled = values.isEncryptionEnabled || false;

        valuesCopy.isMandateRegTatEnabled =
            values.isMandateRegTatEnabled || false;

        valuesCopy.allowOpenMultiPaymentLink =
            values.allowOpenMultiPaymentLink || false;
        if (valuesCopy.isEncryptionEnabled) {
            valuesCopy.encryptionData = values.encryptionData;
        }
        valuesCopy.merchantTxnTat = /^\d+$/.test(values.merchantTxnTat)
            ? parseInt(values.merchantTxnTat, 10)
            : null;

        valuesCopy.mandateRegApprovalTat = /^\d+$/.test(
            values.mandateRegApprovalTat
        )
            ? parseInt(values.mandateRegApprovalTat, 10)
            : null;

        valuesCopy.mandateRegFirstExeTat = /^\d+$/.test(
            values.mandateRegFirstExeTat
        )
            ? parseInt(values.mandateRegFirstExeTat, 10)
            : null;

        valuesCopy.attemptCount = /^\d+$/.test(values.attemptCount)
            ? parseInt(values.attemptCount, 10)
            : null;
        valuesCopy.paymentLinkAttemptDiff = /^\d+$/.test(
            values.paymentLinkAttemptDiff
        )
            ? parseInt(values.paymentLinkAttemptDiff, 10)
            : null;

        valuesCopy.pciExpiryDate = convertToEpoch(certificateDate);

        valuesCopy.whitelistedDomains = extractWhitelistedDomains(values.whitelistedDomains);

        const request = {
            uniqueIdentifier: uniqueId,
            sectionType,
            data: valuesCopy,
        };

        if (isEditMode) {
            const merchantId = last(location.pathname.split('/'));
            const updateRequest = {
                configurationType: 'INTEGRATION',
                entityCode: merchantId || '',
                merchantConfig: {
                    integrationData: valuesCopy,
                },
            };

            const makerDetails = {
                makerId: auth.userDetails.email || '',
                idempotencyId: merchantId,
                eventType: MAKER_CHECKER_EVENT_TYPES.INTEGRATION,
            };

            actions.addMerchantStepUpdateMakerRequest(
                updateRequest,
                sectionType,
                makerDetails
            );
        } else if (isViewMode) {
            onNext();
        } else {
            actions.saveAndContinueRequest(request, sectionType);
        }
    };
    const errorDetails = isEditMode ? updateData : saveData;

    const renderCertificateDateExpiry = useMemo(() => {
        const handleDateChange = (date) => {
            setCertificateDate(date);

            if (!date) {
                setErrorMessage('Date is required.');
                return;
            }

            const currentDate = new Date();
            currentDate.setHours(0, 0, 0, 0);

            if (date < currentDate) {
                setErrorMessage('Date cannot be in the past.');
                return;
            }

            setErrorMessage('');
        };

        return (
            <div className="field-container-certificate">
                <div className={'custom-info-label'} style={{ marginRight: '5px' }}>
                    <p className="lab">Enter PCI DSS Certificate Expiry :</p>
                    {
                        isEditMode && (
                            <Tooltip
                                overlayStyle={{ width: '300px ' }}
                                placement="top"
                                overlay={
                                    'Verify PCI DSS Certificate on changing PCI DSS Certificate Expiry Date '
                                }
                            >
                                <img src={infoIcon} alt={`info`} />
                            </Tooltip>
                        )
                    }
                </div>
                <div className={'datepicker-container'}>
                    <DatePicker
                        name="certificateExpiryDate"
                        id="certificate-expiry-date"
                        selected={certificateDate}
                        onChange={handleDateChange}
                        dateFormat="dd/MM/yyyy"
                        placeholderText="DD/MM/YYYY"
                        minDate={new Date()}
                        isDateOnly={true}
                        onBlur={() => {
                            if (!certificateDate) {
                                setErrorMessage('Date is required.');
                            }
                        }}
                        className="custom-datepicker"
                    />
                    {errorMessage && <p className="error-message">{errorMessage}</p>}
                </div>
            </div>
        );
    }, [certificateDate, errorMessage]);


    useEffect(() => {
        if (formData.initial.pciExpiryDate) {
            setCertificateDate(convertFromEpoch(formData.initial.pciExpiryDate));
        }
    }, [formData.initial]);

    useEffect(() => {
        const shouldAddDomain =
            formData?.values?.isDomainWhitelisted;
    
        const shouldAddOnInit =
            !formData?.initial?.whitelistedDomains;
    
        if (shouldAddOnInit || shouldAddDomain) {
            change('whitelistedDomains', ['']);
        }
    }, [formData.initial, formData.values?.isDomainWhitelisted]);
    


    useEffect(()=>{
        if(formData.initial.whitelistedDomains){
            const editWhiteListedDomain=convertToWhitelistedDomains(formData.initial.whitelistedDomains);
            change('whitelistedDomains', editWhiteListedDomain);
        }
        else{
            change('whitelistedDomains', ['']);
        }

    },[formData.initial.whitelistedDomains])


    return (
        <form
            className="integration-list-form"
            onSubmit={handleSubmit(handleFormSubmit)}
        >
            <div className="integration-tab card">
                <h2 className="tab-title">Integration Detail</h2>
                {errorDetails.error && errorDetails.error.errorMessage ? (
                    <Alert customClass="error-msg">
                        {errorDetails.error.errorMessage}
                    </Alert>
                ) : null}
                <ul className="form-list">
                    <li className="form-section security">
                        <div className="form-field">
                            <p className="label">Select Mode</p>
                            <Field
                                name="keyMode"
                                component={FormElems.Checkbox}
                                labelField="name"
                                wrapperClass="wrap-checkbox"
                                options={getOptions(
                                    initialValues,
                                    getKeyMode(
                                        isEditMode,
                                        auth.userDetails.userLevel
                                    ),
                                    'keyMode'
                                )}
                                valueField="value"
                                isDisabled={isViewMode}
                            />
                        </div>
                        <div className="form-field checkbox-wrap modeCheck">
                            <p className="label">Select Security</p>
                            <Field
                                name="security"
                                component={FormElems.Radio}
                                labelField="name"
                                wrapperClass="wrap-checkbox"
                                defaultSelected={
                                    formData.values && formData.values.security
                                }
                                options={security}
                                valueField="value"
                                disabled={isViewMode}
                            />
                        </div>
                        {isEditMode && (
                            <div className="form-field checkbox-wrap modeCheck">
                                <p className="label">Entity Status</p>
                                <Field
                                    name="entityStatus"
                                    component={FormElems.Radio}
                                    labelField="name"
                                    wrapperClass="wrap-checkbox"
                                    defaultSelected={
                                        formData.values &&
                                        formData.values.entityStatus
                                    }
                                    options={statusOptions}
                                    valueField="value"
                                    disabled={isViewMode}
                                />
                            </div>
                        )}
                    </li>
                    <li className="form-section lastCol">
                        <div className="form-field">
                            <p className="label">Select Platform</p>
                            <Field
                                name="platform"
                                component={FormElems.Checkbox}
                                labelField="name"
                                options={getOptions(
                                    initialValues,
                                    platform,
                                    'platform'
                                )}
                                wrapperClass="wrap-checkbox"
                                valueField="value"
                                isDisabled={isViewMode}
                            />
                        </div>
                    </li>
                    <li className="form-section">
                        <div className="form-field">
                            <p className="label">Select Mode of Integration</p>
                            <Field
                                name="modeOfIntegration"
                                component={FormElems.Checkbox}
                                labelField="name"
                                wrapperClass="wrap-checkbox"
                                options={getOptions(
                                    initialValues,
                                    modeOfIntegration,
                                    'modeOfIntegration',
                                    {
                                        index: 0,
                                        component: renderCertificateDateExpiry,
                                    }
                                )}
                                valueField="value"
                                isDisabled={isViewMode}
                            />
                        </div>
                    </li>
                </ul>

                <Accordion
                    customClass="custom-accordion"
                    id="live-credentials-accordion"
                    upperComponent={
                        <h3 className="accordion-tile">
                            Transaction Configuration
                        </h3>
                    }
                    lowerComponent={
                        <ul className="form-list">
                            <li className="form-section">
                                <div className="form-field">
                                    <Field
                                        name="instantRollback"
                                        component={FormElems.Checkbox}
                                        labelField="name"
                                        wrapperClass="wrap-checkbox"
                                        options={getCheckboxOptions(
                                            formData.values,
                                            instantRollback,
                                            'instantRollback'
                                        )}
                                        valueField="value"
                                        isDisabled={isViewMode}
                                    />
                                </div>
                                <div className="form-field">
                                    <Field
                                        name="verifiedPayment"
                                        component={FormElems.Checkbox}
                                        labelField="name"
                                        wrapperClass="wrap-checkbox"
                                        options={getCheckboxOptions(
                                            formData.values,
                                            verifiedPayment,
                                            'verifiedPayment'
                                        )}
                                        valueField="value"
                                        isDisabled={isViewMode}
                                    />
                                </div>
                                <div className="form-field ">
                                    <Field
                                        name="allowRetry"
                                        component={FormElems.Checkbox}
                                        labelField="name"
                                        wrapperClass="wrap-checkbox"
                                        options={getCheckboxOptions(
                                            formData.values,
                                            allowRetry,
                                            'allowRetry'
                                        )}
                                        valueField="value"
                                        isDisabled={isViewMode}
                                    />
                                </div>
                                {showCount && (
                                    <div className="form-field sub-input-field">
                                        <p className="sub-input-field-label">
                                            Retry Count
                                        </p>
                                        <Field
                                            name="retryCount"
                                            component={FormElems.Select}
                                            getDefaultSelected={
                                                initialValues.retryCount
                                            }
                                            data={[
                                                {
                                                    name: '1',
                                                    value: 1,
                                                },
                                                {
                                                    name: '2',
                                                    value: 2,
                                                },
                                                {
                                                    name: '3',
                                                    value: 3,
                                                },
                                            ]}
                                            labelField="name"
                                            valueField="name"
                                            label="Select Retry Count"
                                            placeholder="Select Retry Count"
                                            disabled={isViewMode}
                                        />
                                    </div>
                                )}
                                <div className="form-field">
                                    <Field
                                        name="isMerchantTatEnabled"
                                        component={FormElems.Checkbox}
                                        labelField="name"
                                        wrapperClass="wrap-checkbox"
                                        options={getCheckboxOptions(
                                            formData.values,
                                            isMerchantTatEnabled,
                                            'isMerchantTatEnabled'
                                        )}
                                        valueField="value"
                                        isDisabled={isViewMode}
                                    />
                                </div>
                                {showMerchantTxnTat && (
                                    <div className="form-field sub-input-field">
                                        <p className="sub-input-field-label">
                                            Rollback TAT (in minutes)
                                        </p>
                                        <Field
                                            name="merchantTxnTat"
                                            type="number"
                                            id="merchantTxnTat"
                                            min="1"
                                            max="14400"
                                            component={FormElems.Input}
                                            placeholder="Enter Merchant Transaction TAT"
                                            disabled={isViewMode}
                                        />
                                    </div>
                                )}

                                <div className="form-field">
                                    <Field
                                        name="isMandateRegTatEnabled"
                                        component={FormElems.Checkbox}
                                        labelField="name"
                                        wrapperClass="wrap-checkbox"
                                        options={getCheckboxOptions(
                                            formData.values,
                                            isMandateRegTatEnabled,
                                            'isMandateRegTatEnabled'
                                        )}
                                        valueField="value"
                                        isDisabled={isViewMode}
                                    />
                                </div>
                                {showMandateRegTxnTat && (
                                    <div className="form-field sub-input-field">
                                        <p className="sub-input-field-label">
                                            Mandate Registration TAT (in
                                            minutes)
                                        </p>
                                        <Field
                                            name="mandateRegApprovalTat"
                                            type="number"
                                            id="mandateRegApprovalTat"
                                            component={FormElems.Input}
                                            placeholder="Enter Mandate Registration TAT"
                                            disabled={isViewMode}
                                        />
                                    </div>
                                )}
                                {showMandateRegTxnTat && (
                                    <div className="form-field sub-input-field">
                                        <p className="sub-input-field-label">
                                            First Mandate Registration Execution
                                            TAT (in minutes)
                                        </p>
                                        <Field
                                            name="mandateRegFirstExeTat"
                                            type="number"
                                            id="mandateRegFirstExeTat"
                                            component={FormElems.Input}
                                            placeholder="Enter First Mandate Registration Execution TAT"
                                            disabled={isViewMode}
                                        />
                                    </div>
                                )}
                            </li>
                        </ul>
                    }
                />

                <Accordion
                    customClass="custom-accordion"
                    id="live-credentials-accordion"
                    upperComponent={
                        <h3 className="accordion-tile">Refund Configuration</h3>
                    }
                    lowerComponent={
                        <ul className="form-list">
                            <li className="form-section">
                                <div className="form-field">
                                    <Field
                                        name="instantRefund"
                                        component={FormElems.Checkbox}
                                        labelField="name"
                                        wrapperClass="wrap-checkbox"
                                        options={getCheckboxOptions(
                                            formData.values,
                                            instantRefund,
                                            'instantRefund'
                                        )}
                                        valueField="value"
                                        isDisabled={isViewMode}
                                    />
                                </div>
                                <div className="form-field">
                                    <Field
                                        name="refundRetry"
                                        component={FormElems.Checkbox}
                                        labelField="name"
                                        wrapperClass="wrap-checkbox"
                                        options={getCheckboxOptions(
                                            formData.values,
                                            refundRetry,
                                            'refundRetry'
                                        )}
                                        valueField="value"
                                        isDisabled={isViewMode}
                                    />
                                </div>
                                <div className="form-field">
                                    <Field
                                        name="refundQueue"
                                        component={FormElems.Checkbox}
                                        labelField="name"
                                        wrapperClass="wrap-checkbox"
                                        defaultSelected={false}
                                        options={getCheckboxOptions(
                                            formData.values,
                                            refundQueue,
                                            'refundQueue'
                                        )}
                                        valueField="value"
                                        isDisabled={isViewMode}
                                    />
                                </div>
                                {getRefundQueueValue(formData) && (
                                    <div className="form-field sub-input-field">
                                        <p className="sub-input-field-label" style={{ marginBottom: '10px' }}>
                                            Refund Queue TAT in Minutes
                                        </p>
                                        <Field
                                            name="refundQueueTat"
                                            type="number"
                                            id="refundQueueTat"
                                            min="1440"
                                            component={FormElems.Input}
                                            placeholder="Enter Refund Queue TAT in Minutes"
                                            disabled={isViewMode}
                                        />
                                    </div>
                                )}
                            </li>
                        </ul>
                    }
                />

                <Accordion
                    customClass="custom-accordion"
                    id="live-credentials-accordion"
                    upperComponent={
                        <h3 className="accordion-tile">
                            Payment Link Configuration
                        </h3>
                    }
                    lowerComponent={
                        <ul className="form-list">
                            <li className="form-section">
                                <div className="form-field">
                                    <Field
                                        name="allowOpenMultiPaymentLink"
                                        component={FormElems.Checkbox}
                                        labelField="name"
                                        wrapperClass="wrap-checkbox"
                                        options={getCheckboxOptions(
                                            formData.values,
                                            allowOpenMultiPaymentLink,
                                            'allowOpenMultiPaymentLink'
                                        )}
                                        valueField="value"
                                        isDisabled={isViewMode}
                                    />
                                </div>
                                <div className="form-field">
                                    <Field
                                        name="isMultiAttemptOnPayLink"
                                        component={FormElems.Checkbox}
                                        labelField="name"
                                        wrapperClass="wrap-checkbox"
                                        options={getCheckboxOptions(
                                            formData.values,
                                            isMultiAttemptOnPayLink,
                                            'isMultiAttemptOnPayLink'
                                        )}
                                        valueField="value"
                                        isDisabled={isViewMode}
                                    />
                                </div>
                                {showPayLinkConfigs && (
                                    <div className="form-field sub-input-field">
                                        <p className="sub-input-field-label">
                                            Attempt Count
                                        </p>
                                        <Field
                                            name="attemptCount"
                                            type="number"
                                            id="attemptCount"
                                            min="1"
                                            max="20"
                                            component={FormElems.Input}
                                            placeholder="Enter Attempt Count"
                                            disabled={isViewMode}
                                        />
                                    </div>
                                )}
                                {showPayLinkConfigs && (
                                    <div className="form-field sub-input-field">
                                        <p className="sub-input-field-label">
                                            Time Difference between two attempts
                                            (in minutes)
                                        </p>
                                        <Field
                                            name="paymentLinkAttemptDiff"
                                            type="number"
                                            id="paymentLinkAttemptDiff"
                                            min="1"
                                            max="999"
                                            component={FormElems.Input}
                                            placeholder="Enter time difference in minutes"
                                            disabled={isViewMode}
                                        />
                                    </div>
                                )}
                            </li>
                        </ul>
                    }
                />

                <Accordion
                    customClass="custom-accordion"
                    id="live-credentials-accordion"
                    upperComponent={
                        <h3 className="accordion-tile">
                            Merchant Configuration
                        </h3>
                    }
                    lowerComponent={
                        <ul className="form-list">
                            <li className="form-section">
                                <div className="form-field">
                                    <Field
                                        name="isFcMerchant"
                                        component={FormElems.Checkbox}
                                        labelField="name"
                                        wrapperClass="wrap-checkbox"
                                        options={getCheckboxOptions(
                                            formData.values,
                                            isFcMerchant,
                                            'isFcMerchant'
                                        )}
                                        valueField="value"
                                        isDisabled={isViewMode}
                                    />
                                </div>
                                <div className="form-field">
                                    <Field
                                        name="isStaticQREnabled"
                                        component={FormElems.Checkbox}
                                        labelField="name"
                                        wrapperClass="wrap-checkbox"
                                        options={getCheckboxOptions(
                                            formData.values,
                                            isStaticQREnabled,
                                            'isStaticQREnabled'
                                        )}
                                        valueField="value"
                                        isDisabled={isViewMode}
                                    />
                                </div>
                                <div className="form-field ">
                                    <Field
                                        name="isSftpRequired"
                                        component={FormElems.Checkbox}
                                        labelField="name"
                                        wrapperClass="wrap-checkbox"
                                        options={getCheckboxOptions(
                                            formData.values,
                                            sftpReport,
                                            'isSftpRequired'
                                        )}
                                        valueField="value"
                                        isDisabled={isViewMode}
                                    />
                                </div>
                                <div className="form-field ">
                                    <Field
                                        name="isMtrViaEmailRequired"
                                        component={FormElems.Checkbox}
                                        labelField="name"
                                        wrapperClass="wrap-checkbox"
                                        options={getCheckboxOptions(
                                            formData.values,
                                            mtrViaEmailRequired,
                                            'isMtrViaEmailRequired'
                                        )}
                                        valueField="value"
                                        isDisabled={isViewMode}
                                    />
                                </div>
                                <div className="form-field ">
                                    <Field
                                        name="isMerTxnLimitEnabled"
                                        component={FormElems.Checkbox}
                                        labelField="name"
                                        wrapperClass="wrap-checkbox"
                                        options={getCheckboxOptions(
                                            formData.values,
                                            merchantTxnLimit,
                                            'isMerTxnLimitEnabled'
                                        )}
                                        valueField="value"
                                        isDisabled={isViewMode}
                                    />
                                </div>
                                {formData.values &&
                                    formData.values.isMerTxnLimitEnabled && (
                                        <div className="txn-limit-field-wrap">
                                            <div className="form-field txn-limit">
                                                <p className="txn-limit-label">
                                                    Per Transaction Limit
                                                </p>
                                                <Field
                                                    name="perTransactionLimit"
                                                    type="number"
                                                    id="perTransactionLimit"
                                                    min={1}
                                                    component={FormElems.Input}
                                                    placeholder="Per transaction limit"
                                                    disabled={isViewMode}
                                                    required={true}
                                                    step=".0001"
                                                />
                                            </div>
                                            <div className="form-field txn-limit">
                                                <p className="txn-limit-label">
                                                    Daily Transaction Limit
                                                </p>
                                                <Field
                                                    name="dailyTransactionLimit"
                                                    type="number"
                                                    id="dailyTransactionLimit"
                                                    min={1}
                                                    component={FormElems.Input}
                                                    placeholder="Daily transaction limit"
                                                    disabled={isViewMode}
                                                    required={true}
                                                    step=".0001"
                                                />
                                            </div>
                                            <div className="form-field txn-limit">
                                                <p className="txn-limit-label">
                                                    Monthly Transaction Limit
                                                </p>
                                                <Field
                                                    name="monthlyTransactionLimit"
                                                    type="number"
                                                    id="monthlyTransactionLimit"
                                                    min={1}
                                                    component={FormElems.Input}
                                                    placeholder="Monthly transaction limit"
                                                    disabled={isViewMode}
                                                    required={true}
                                                    step=".0001"
                                                />
                                            </div>
                                        </div>
                                    )}
                            </li>
                        </ul>
                    }
                />

                <Accordion
                    customClass="custom-accordion"
                    id="live-credentials-accordion"
                    upperComponent={
                        <h3 className="accordion-tile">
                            Security Configuration
                        </h3>
                    }
                    lowerComponent={
                        <ul className="form-list">
                            <li className="form-section encryption">
                                <div className="form-field checkbox-wrap retry-check">
                                    <Field
                                        name="allowFPS"
                                        component={FormElems.Checkbox}
                                        labelField="name"
                                        wrapperClass="wrap-checkbox"
                                        options={getCheckboxOptions(
                                            formData.values,
                                            allowFPS,
                                            'allowFPS'
                                        )}
                                        valueField="value"
                                        isDisabled={isViewMode}
                                    />
                                    <Field
                                        name="threeDimensionSecurityBrowserInfoCollect"
                                        component={FormElems.Checkbox}
                                        labelField="name"
                                        wrapperClass="wrap-checkbox"
                                        options={getCheckboxOptions(
                                            formData.values,
                                            threeDimensionSecurityBrowserInfoCollect,
                                            'threeDimensionSecurityBrowserInfoCollect'
                                        )}
                                        valueField="value"
                                        isDisabled={isViewMode}
                                    />
                                    <Field
                                        name="threeDimensionSecurityInfoHardCoded"
                                        component={FormElems.Checkbox}
                                        labelField="name"
                                        wrapperClass="wrap-checkbox"
                                        options={getCheckboxOptions(
                                            formData.values,
                                            threeDimensionSecurityInfoHardCoded,
                                            'threeDimensionSecurityInfoHardCoded'
                                        )}
                                        valueField="value"
                                        isDisabled={isViewMode}
                                    />
                                    <Field
                                        name="isEncryptionEnabled"
                                        component={FormElems.Checkbox}
                                        labelField="name"
                                        wrapperClass="wrap-checkbox"
                                        options={getCheckboxOptions(
                                            formData.values,
                                            isEncryptionEnabled,
                                            'isEncryptionEnabled'
                                        )}
                                        valueField="value"
                                        isDisabled={isViewMode}
                                    />
                                </div>

                                {showEncryptionKeys && (
                                    <div className="form-field">
                                        <p className="label">
                                            Test Encryption Key
                                        </p>
                                        <Field
                                            name="encryptionData.encTestKey"
                                            id="encryptionData.encTestKey"
                                            component={FormElems.Input}
                                            placeholder="Enter test encryption key"
                                            disabled={isViewMode}
                                        />
                                    </div>
                                )}

                                {showEncryptionKeys &&
                                    auth.userDetails.userLevel === 'ADMIN' && (
                                        <div className="form-field p-5">
                                            <p className="label">
                                                Live Encryption Key
                                            </p>
                                            <Field
                                                name="encryptionData.encLiveKey"
                                                id="encryptionData.encLiveKey"
                                                component={FormElems.Input}
                                                placeholder="Enter live encryption key"
                                                disabled={isViewMode}
                                            />
                                        </div>
                                    )}
                                <div className='form-field checkbox-wrap retry-check'>
                                    <Field
                                            name="isDomainWhitelisted"
                                            component={FormElems.Checkbox}
                                            labelField="name"
                                            wrapperClass="wrap-checkbox"
                                            options={getCheckboxOptions(
                                                formData.values,
                                                isDomainWhitelisted,
                                                'isDomainWhitelisted'
                                            )}
                                            valueField="value"
                                            isDisabled={isViewMode}
                                        />
                                    {showDomains && (
                                        <FieldArray
                                            name="whitelistedDomains"
                                            component={RenderDomainFields}
                                            props={{ isViewMode}}
                                    />
                                    )}
                                </div>
                            </li>
                        </ul>
                    }
                />
            </div>
            <div className="form-section action">
                {!isViewMode &&(
                    <>
                    {previousPath ? (
                        <FormElems.Button
                            buttonType="secondary"
                            id="back-btn"
                            text="BACK"
                            type="button"
                            handleClick={onBack}
                            customClass="back-btn"
                        />
                    ) : null}
                    <FormElems.Button
                        id="next-btn"
                        buttonType="primary"
                        text="NEXT"
                    />
                </>
            )}
            </div>
        </form>
    );
};

IntegrationTab.propTypes = {
    actions: PropTypes.object,
    auth: PropTypes.object,
    merchantData: PropTypes.object.isRequired,
    isEditMode: PropTypes.bool,
    handleSubmit: PropTypes.func,
    history: PropTypes.object,
    nextPath: PropTypes.string,
    previousPath: PropTypes.string,
    sectionType: PropTypes.string,
    name: PropTypes.string,
    initialValues: PropTypes.object,
    formData: PropTypes.object,
    editData: PropTypes.object,
    isViewMode: PropTypes.bool,
    change: PropTypes.func,
};

const mapStateToProps = ({ auth, form, merchantData, editData }) => ({
    auth,
    formData: form['integration-form'],
    merchantData,
    editData,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            saveAndContinueRequest,
            resetSaveDataSuccessKey,
            updateSectionDataRequest,
            addMerchantStepUpdateMakerRequest,
            getMerchantSectionInfoRequest,
            resetUpdateDataSuccessKey,
        },
        dispatch
    ),
});

export default withRouter(
    compose(
        reduxForm({
            form: 'integration-form',
            enableReinitialize: true,
            validate,
        }),
        connect(mapStateToProps, mapDispatchToProps)
    )(IntegrationTab)
);
